export { default as outpatientData } from './outpatient-data';
export * from './outpatient-data';
